import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0";

const CARD_CONFIG = [
  { icon: "👁️", color: TEAL, bg: "rgba(6,214,160,0.12)" },
  { icon: "🎯", color: CORAL, bg: "rgba(255,107,107,0.12)" },
  { icon: "💎", color: YELLOW, bg: "rgba(255,211,61,0.18)" },
];

const VisionMissionSection = ({ cards }) => (
  <AnimatedSection sx={{ backgroundColor: CORAL, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
    {/* Background polka dots */}
    {[20, 60, 90].map((top, i) => [10, 50, 80].map((left, j) => (
      <Box key={`${i}-${j}`} sx={{ position: "absolute", top: `${top}%`, left: `${left}%`, width: 8, height: 8, borderRadius: "50%", backgroundColor: `rgba(27,31,59,0.12)` }} />
    )))}

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Box sx={{ display: "inline-block", px: 2, py: 0.5, mb: 2, borderRadius: "8px", border: `2px solid ${NAVY}`, backgroundColor: YELLOW, fontFamily: "'Space Grotesk',sans-serif", fontWeight: 800, fontSize: "0.78rem", letterSpacing: "0.1em", color: NAVY, textTransform: "uppercase" }}>
          Vision & Mission
        </Box>
        <Typography sx={{ fontFamily: "'Fredoka One',cursive", fontSize: { xs: "2rem", md: "2.8rem" }, color: "#fff", lineHeight: 1.15 }}>
          Our Promise to Every Child 💎
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {cards.map((card, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box sx={{ p: 4, height: "100%", borderRadius: "18px", border: `2.5px solid ${NAVY}`, backgroundColor: "#fff", boxShadow: `6px 6px 0 ${NAVY}`, transition: "all 0.2s ease", "&:hover": { transform: "translate(-3px,-3px)", boxShadow: `9px 9px 0 ${NAVY}` } }}>
              <Box sx={{ width: 60, height: 60, borderRadius: "14px", backgroundColor: CARD_CONFIG[i].bg, border: `2px solid ${NAVY}`, display: "grid", placeItems: "center", fontSize: "1.8rem", mb: 2.5, animation: `wiggle ${2.5 + i * 0.4}s ease-in-out infinite` }}>
                {CARD_CONFIG[i].icon}
              </Box>
              <Typography sx={{ fontFamily: "'Fredoka One',cursive", fontSize: "1.4rem", color: CARD_CONFIG[i].color, mb: 1.5, WebkitTextStroke: `1px ${NAVY}` }}>
                {card.title}
              </Typography>
              <Typography sx={{ color: "#4A4E6D", fontWeight: 600, lineHeight: 1.8, fontSize: "0.93rem" }}>
                {card.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </AnimatedSection>
);

export default VisionMissionSection;
